var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('div',{staticClass:"dialog-loading"},[_c('v-progress-circular',{attrs:{"size":48,"indeterminate":"","color":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }